export const initialState = {
  balances: {},
  direction: 'out',
  // the conversion waits on the partner crediting the points, so the wait needs to show
  converting: false,
  selectedRate: null,
  modal: {
    visible: false,
    closeAction: null,
    text: {},
  },
};

export const exchangeConversionReducer = (state, action) => {
  switch (action.type) {
    case 'SET_BALANCES':
      return { ...state, balances: action.payload };
    case 'TOGGLE_DIRECTION':
      const { selectedRate } = action;
      return { ...state, direction: state.direction === 'in' ? 'out' : 'in', selectedRate };
    case 'SET_SELECTED_RATE':
      return { ...state, selectedRate: action.payload };
    case 'SET_CONVERTING':
      return { ...state, converting: action.payload };
    case 'SET_MODAL_VISIBLE':
      return { ...state, modal: { ...state.modal, visible: action.payload } };
    case 'SET_MODAL_CLOSE_ACTION':
      return { ...state, modal: { ...state.modal, closeAction: action.payload } };
    case 'SET_MODAL_TEXT':
      return { ...state, modal: { ...state.modal, text: action.payload } };
    default:
      return state;
  }
};
